import { AccordionGroup } from '@talos/kyoko';
import { forwardRef, memo, type Ref } from 'react';
import { SearchList } from './SearchList/SearchList';
import type { MarketAccountSelectionProps } from './types';
import { withMarketAccountSelection } from './withMarketAccountSelection';

const MarketAccountSearchListInner = withMarketAccountSelection(SearchList);

export const MarketAccountSearchList = memo(
  forwardRef((props: MarketAccountSelectionProps, ref: Ref<HTMLInputElement>) => {
    return (
      <AccordionGroup>
        <MarketAccountSearchListInner {...props} inputRef={ref} />
      </AccordionGroup>
    );
  })
);
